import { EventBus as _EventBus } from 'components/eventBus/EventBus';

export const EventBus = new _EventBus();

// eslint-disable-next-line @typescript-eslint/typedef
export const ConfigProviderEvents = {
  configUpdated: 'configProvider.configUpdated',
};

type TConfigKey = string;

export type TConfigUpdatedKey = `configProvider.configUpdated.${TConfigKey}`;

export type TEventBusEvents<TConfig> = {
  [key: TConfigUpdatedKey]: TConfig;
};

// export const getFieldSpecificEventName: (key: TConfigKey) => TConfigUpdatedKey = (key) =>
export const getFieldSpecificEventName: (key: any) => TConfigUpdatedKey = (key) =>
  `${ConfigProviderEvents.configUpdated}.${key}` as TConfigUpdatedKey;
